import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, CustomPageReducer, CustomPageState } from "./custom-page-reducer";

const CustomPageContext = createContext<CustomPageState | undefined>(undefined);
const CustomPageContextDispatchContext = createContext({} as any);

const CustomPageProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(CustomPageReducer, {
        customPage: undefined,
        loading: false,
        error: undefined,
    } as CustomPageState);

    return (
        <CustomPageContext.Provider value={state}>
            <CustomPageContextDispatchContext.Provider value={dispatch}>
                {children}
            </CustomPageContextDispatchContext.Provider>
        </CustomPageContext.Provider>
    );
}

const useCustomPageState = () => {
    const context = useContext(CustomPageContext);
    if (context === undefined) {
        throw new Error('useCustomPageState must be used within a CustomPageProvider');
    }
    return context;
}

const useCustomPageDispatch = () => {
    const context = useContext(CustomPageContextDispatchContext);
    if (context === undefined) {
        throw new Error('useCustomPageDispatch must be used within a CustomPageProvider');
    }
    return context;
}

export { CustomPageProvider, useCustomPageState, useCustomPageDispatch, ACTION_TYPES };
